import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { comprobantesApi } from '../api/comprobantes';
import { toast } from 'sonner';

export function useComprobantes() {
  return useQuery({
    queryKey: ['comprobantes'],
    queryFn: async () => {
      const response = await comprobantesApi.getAll();
      return response || [];
    },
    staleTime: 1000 * 60 * 2,
  });
}

export function useComprobante(id: number) {
  return useQuery({
    queryKey: ['comprobantes', id],
    queryFn: async () => {
      const response = await comprobantesApi.getById(id);
      return response || null;
    },
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useCreateComprobante() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => comprobantesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comprobantes'] });
      toast.success('Comprobante creado exitosamente');
    },
    onError: (error: any) => {
      console.error('Error en create:', error);
      toast.error(error.response?.data?.error || 'Error al crear el comprobante');
    },
  });
}

export function useUpdateComprobante() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      comprobantesApi.update(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['comprobantes'] });
      queryClient.invalidateQueries({ queryKey: ['comprobantes', id] });
      toast.success('Comprobante actualizado exitosamente');
    },
    onError: (error: any) => {
      console.error('Error en update:', error);
      toast.error(error.response?.data?.error || 'Error al actualizar el comprobante');
    },
  });
}

export function useDeleteComprobante() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => comprobantesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comprobantes'] });
      toast.success('Comprobante eliminado exitosamente');
    },
    onError: (error: any) => {
      console.error('Error en delete:', error);
      toast.error(error.response?.data?.error || 'Error al eliminar el comprobante');
    },
  });
}

export function useGeneratePDF() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => comprobantesApi.generatePDF(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comprobantes'] });
    },
    onError: (error: any) => {
      console.error('Error en generatePDF:', error);
    },
  });
}